module.exports = __webpack_public_path__ + "static/media/nsa_logo.11a68e0d.svg";